export const CONTROL_DIMENSION = 48;
export const ITEM_SPACING = 16;
export const IMAGE_TO_CAROUSEL_WIDTH_RATIO = 7 / 8;
